import { render, staticRenderFns } from "./VpnSupportModal.vue?vue&type=template&id=833e9886&scoped=true"
import script from "./VpnSupportModal.vue?vue&type=script&lang=js"
export * from "./VpnSupportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833e9886",
  null
  
)

export default component.exports